export const environment = {
  production: true,
  /**
   * Public API host — must be a verified custom domain (never a SmarterASP temporary hostname).
   * Bind `api.zerotechstores.com` + SSL to the API site in SmarterASP before deploy.
   */
  apiUrl: 'https://api.zerotechstores.com/api',
  /**
   * Optional CDN origin for `/uploads` and `/api/media/image`.
   * Leave empty to use the API host derived from `apiUrl`.
   */
  mediaCdnOrigin: '',
  /** External product image hosts resized via `/api/media/image?url=`. */
  mediaProxyHosts: ['zerotech.fsn1.your-objectstorage.com'],
  branchId: 1,
  /** 0 = Store, 1 = Electronics. */
  platform: 0,
  paymobIframeId: '883994',
  metaPixelId: '1431624488632222',
  ga4MeasurementId: '',
  featureFlags: {
    croRecentlyViewed: true,
    croStockAlerts: false,
    croPriceDropAlerts: false,
  },
};
